module.exports = __webpack_public_path__ + "img/zombieoffice_9.5dfe4b55.jpg";